(function () {
  const STORAGE_KEY = "ss_aircon_compare_items";
  const MAX_COMPARE = 4;

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getList() {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(list) ? list.filter((item) => item && item.handle) : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function getProductFromButton(button) {
    return {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle || button.dataset.productHandle,
      url: button.dataset.productUrl || "#",
      image: button.dataset.productImage || "",
      variant_id: button.dataset.productVariantId || "",
      price: button.dataset.productPrice || "-",
      compare_at_price: button.dataset.productCompareAtPrice || "",
      on_sale: button.dataset.productOnSale === "true",
      brand: button.dataset.productBrand || "-",
      cooling: button.dataset.productCooling || "-",
      heating: button.dataset.productHeating || "-",
      cover_size: button.dataset.productCoverSize || "-",
      noise_level: button.dataset.productNoiseLevel || "-",
      energy_rating: button.dataset.productEnergyRating || "-",
      warranty: button.dataset.productWarranty || "-",
      pair_coil_size: button.dataset.productPairCoilSize || "-",
      wifi: button.dataset.productWifi || "-",
      peaksmart: button.dataset.productPeaksmart || "-",
    };
  }

  function addCompare(product) {
    if (!product.handle) return;

    const list = getList();

    if (list.some((item) => item.handle === product.handle)) return;

    if (list.length >= MAX_COMPARE) {
      alert("You can compare up to 4 air conditioners.");
      return;
    }

    list.push(product);
    saveList(list);
  }

  function removeCompare(handle) {
    saveList(getList().filter((item) => item.handle !== handle));
  }

  function clearCompare() {
    saveList([]);
  }

  function updateButtons() {
    const list = getList();
    const handles = list.map((item) => item.handle);

    document.querySelectorAll("[data-ss-add-compare]").forEach((button) => {
      const handle = button.dataset.productHandle;

      if (handles.includes(handle)) {
        button.classList.add("is-added");
        button.textContent = "Comparing";
      } else {
        button.classList.remove("is-added");
        button.textContent = "Compare";
      }
    });

    const floating = document.querySelector("[data-ss-compare-floating]");
    const count = document.querySelector("[data-ss-compare-count]");
    const selectedItems = document.querySelector("[data-ss-compare-selected-items]");

    if (floating) {
      floating.classList.toggle("is-visible", list.length > 0);
    }

    if (count) {
      count.textContent = list.length;
    }

    if (selectedItems) {
      selectedItems.innerHTML = list
        .map((item) => {
          return `
            <div class="ss-compare-pill">
              <span class="ss-compare-pill__title">${escapeHtml(item.title)}</span>
              <button
                type="button"
                class="ss-compare-pill__remove"
                data-ss-remove-compare="${escapeHtml(item.handle)}"
                aria-label="Remove ${escapeHtml(item.title)}"
              >
                ×
              </button>
            </div>
          `;
        })
        .join("");
    }
  }

    function renderEnergyStars(value) {
  const number = parseFloat(value);

  if (isNaN(number) || number <= 0) {
    return "-";
  }

  const rating = Math.min(Math.max(number, 0), 5);
  let starsHtml = "";

  for (let i = 1; i <= 5; i++) {
    let fill = 0;

    if (rating >= i) {
      fill = 100;
    } else if (rating > i - 1) {
      fill = (rating - (i - 1)) * 100;
    }

    const clipId = `ss-star-clip-${Math.random().toString(36).slice(2, 9)}`;

    starsHtml += `
      <svg class="ss-svg-star" viewBox="0 0 24 24" aria-hidden="true">
        <defs>
          <clipPath id="${clipId}">
            <rect x="0" y="0" width="${fill}%" height="24"></rect>
          </clipPath>
        </defs>

        <path
          class="ss-svg-star-base"
          d="M12 2.5L14.9 8.7L21.6 9.5L16.6 14.1L17.9 20.8L12 17.4L6.1 20.8L7.4 14.1L2.4 9.5L9.1 8.7L12 2.5Z"
        ></path>

        <path
          class="ss-svg-star-fill"
          clip-path="url(#${clipId})"
          d="M12 2.5L14.9 8.7L21.6 9.5L16.6 14.1L17.9 20.8L12 17.4L6.1 20.8L7.4 14.1L2.4 9.5L9.1 8.7L12 2.5Z"
        ></path>
      </svg>
    `;
  }

  return `
    <div class="ss-energy-stars-wrap">
      <div class="ss-svg-star-rating" aria-label="${rating.toFixed(1)} out of 5 stars">
        ${starsHtml}
      </div>
      <span class="ss-energy-rating-number">${rating.toFixed(1)}</span>
    </div>
  `;
}

  function formatCoverSize(value) {
    const raw = String(value || "").trim();

    if (!raw || raw === "-") return "-";

    let roomType = "Small Rooms";

    if (raw.includes("10-20")) {
      roomType = "Small Rooms";
    } else if (raw.includes("20-35")) {
      roomType = "Medium Rooms";
    } else if (raw.includes("35-50")) {
      roomType = "Large Rooms";
    } else if (raw.includes("50-75") || raw.includes("75+")) {
      roomType = "Open Plan Spaces";
    }

    return `
      <div class="ss-cover-size-wrap">
        <span class="ss-cover-size-number">${raw}</span>
        <span class="ss-cover-size-label">${roomType}</span>
      </div>
    `;
  }

  function renderPrice(product, isDifferent) {
    const diffClass = isDifferent ? " ss-compare-diff-cell" : "";

    if (product.on_sale && product.compare_at_price) {
      return `
        <div class="ss-compare-price${diffClass}">
          <span class="ss-compare-sale-price">${escapeHtml(product.price)}</span>
          <span class="ss-compare-original-price">${escapeHtml(product.compare_at_price)}</span>
          <span class="ss-compare-sale-badge">Sale</span>
        </div>
      `;
    }

    return `
      <div class="ss-compare-price${diffClass}">
        <span class="ss-compare-regular-price">${escapeHtml(product.price)}</span>
      </div>
    `;
  }

  function renderValue(value, key, isDifferent) {
    const safeValue = escapeHtml(value || "-");
    const diffClass = isDifferent ? " ss-compare-diff-cell" : "";

    if (safeValue === "Yes") {
      return `<span class="ss-compare-yes${diffClass}">Yes</span>`;
    }

    if (safeValue === "No") {
      return `<span class="ss-compare-no${diffClass}">No</span>`;
    }

    if (key === "peaksmart" && safeValue !== "-") {
      return `<span class="ss-compare-tag${diffClass}">${safeValue}</span>`;
    }

    if (key === "cover_size" && safeValue !== "-") {
      return formatCoverSize(safeValue);
    }

    if (key === "energy_rating" && safeValue !== "-") {
      return `
        <span class="ss-compare-energy${diffClass}">
          ${renderEnergyStars(safeValue)}
        </span>
      `;
    }

    return `<span class="${isDifferent ? "ss-compare-diff-text" : ""}">${safeValue}</span>`;
  }

  function rowHasDifference(products, key) {
    const values = products.map((product) => {
      if (key === "price") {
        return `${product.price || "-"}|${product.compare_at_price || ""}`;
      }

      return String(product[key] || "-").trim().toLowerCase();
    });

    return new Set(values).size > 1;
  }

    function openCartDrawer() {
        const cartDrawer = document.querySelector("cart-drawer-component");
        const cartItems = cartDrawer?.querySelector("cart-items-component");
        const sectionId = cartItems?.dataset.sectionId;

        if (!cartDrawer || !cartItems || !sectionId) {
            console.warn("Cart drawer component or section id not found.");
            return;
        }

        fetch(`${window.Shopify.routes.root}?sections=${sectionId}`)
            .then((response) => response.json())
            .then((sections) => {
            const html = sections[sectionId];
            if (!html) return;

            const doc = new DOMParser().parseFromString(html, "text/html");

            const newCartItems = doc.querySelector("cart-items-component");
            const currentCartItems = cartDrawer.querySelector("cart-items-component");

            const newDialog = doc.querySelector("cart-drawer-component dialog");
            const currentDialog = cartDrawer.querySelector("dialog");

            const newCartBubble = doc.querySelector(".cart-bubble");
            const currentCartBubble = cartDrawer.querySelector(".cart-bubble");

            if (newCartItems && currentCartItems) {
                currentCartItems.innerHTML = newCartItems.innerHTML;
            }

            if (newDialog && currentDialog) {
                currentDialog.className = newDialog.className;
            }

            if (newCartBubble && currentCartBubble) {
                currentCartBubble.innerHTML = newCartBubble.innerHTML;
                currentCartBubble.className = newCartBubble.className;
            }

            if (currentDialog && !currentDialog.open) {
                currentDialog.showModal();
            }
            })
            .catch((error) => {
            console.warn("Cart drawer refresh failed:", error);
            });
        }

  function renderComparePage() {
    const root = document.querySelector("[data-ss-compare-root]");
    if (!root) return;

    const selectedProducts = getList();

    const empty = root.querySelector("[data-ss-compare-empty]");
    const tableWrap = root.querySelector("[data-ss-compare-table-wrap]");
    const table = root.querySelector("[data-ss-compare-table]");

    if (!empty || !tableWrap || !table) return;

    if (!selectedProducts.length) {
      empty.style.display = "block";
      tableWrap.style.display = "none";
      table.innerHTML = "";
      return;
    }

    empty.style.display = "none";
    tableWrap.style.display = "block";

    const productHeaders = selectedProducts
      .map((product) => {
        const imageHtml = product.image
          ? `<a href="${escapeHtml(product.url)}" class="ss-compare-product-image-link">
              <img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">
            </a>`
          : `<div class="ss-compare-product-image-placeholder">No image</div>`;

        return `
          <th>
            <div class="ss-compare-product">
              ${imageHtml}

              <div class="ss-compare-product-title">
                ${escapeHtml(product.title)}
              </div>

              ${renderPrice(product, false)}

              ${
                product.variant_id
                  ? `
                    <button
                      type="button"
                      class="ss-compare-cart-btn"
                      data-ss-compare-add-cart
                      data-variant-id="${escapeHtml(product.variant_id)}"
                    >
                      Add to cart
                    </button>
                  `
                  : ""
              }

              <button
                type="button"
                class="ss-remove-compare"
                data-ss-remove-compare="${escapeHtml(product.handle)}"
              >
                Remove
              </button>
            </div>
          </th>
        `;
      })
      .join("");

    const rows = [
      ["Brand", "brand"],
      ["Cooling Capacity (kW)", "cooling"],
      ["Heating Capacity (kW)", "heating"],
      ["Coverage Size (m²)", "cover_size"],
      ["Noise Level (dB(A))", "noise_level"],
      ["Energy Rating", "energy_rating"],
      ["Warranty", "warranty"],
      ["WiFi", "wifi"],
      ["PeakSmart", "peaksmart"],
      ["Pair Coil Size", "pair_coil_size"],
    ];

    const highlightDifferences =
      root.getAttribute("data-show-differences-only") === "true";

    const bodyRows = rows
      .map(([label, key]) => {
        const isDifferent =
          highlightDifferences && rowHasDifference(selectedProducts, key);

        const rowClass = isDifferent ? ' class="ss-compare-difference-row"' : "";

        const cells = selectedProducts
          .map((product) => {
            const cellClass = isDifferent ? ' class="ss-compare-highlight-bg"' : "";

            return `<td${cellClass}>${renderValue(product[key], key, isDifferent)}</td>`;
          })
          .join("");

        return `
          <tr${rowClass}>
            <td>
              <span class="ss-compare-feature-label">${escapeHtml(label)}</span>
            </td>
            ${cells}
          </tr>
        `;
      })
      .join("");

    table.innerHTML = `
      <thead>
        <tr>
          <th>Products</th>
          ${productHeaders}
        </tr>
      </thead>
      <tbody>
        ${bodyRows}
      </tbody>
    `;
  }

  document.addEventListener(
    "click",
    function (event) {
      const compareCartButton = event.target.closest("[data-ss-compare-add-cart]");

      if (compareCartButton) {
        event.preventDefault();
        event.stopPropagation();

        const variantId = compareCartButton.dataset.variantId;

        if (!variantId) return;

        compareCartButton.disabled = true;
        compareCartButton.textContent = "Adding...";

        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                id: Number(variantId),
                quantity: 1,
            }),
            })
            .then((response) => {
                if (!response.ok) {
                throw new Error("Add to cart failed");
                }

                return response.json();
            })
            .then(() => {
                compareCartButton.textContent = "Added";
                openCartDrawer();
            })
            .catch(() => {
                compareCartButton.textContent = "Try again";
            })
            .finally(() => {
                setTimeout(() => {
                compareCartButton.disabled = false;
                compareCartButton.textContent = "Add to cart";
                }, 1500);
            });

        return;
      }

    const addButton = event.target.closest("[data-ss-add-compare]");

        if (addButton) {
        event.preventDefault();
        event.stopPropagation();

        const product = getProductFromButton(addButton);
        const list = getList();

        const alreadyAdded = list.some(
            (item) => item.handle === product.handle
        );

        if (alreadyAdded) {
            removeCompare(product.handle);
        } else {
            addCompare(product);
        }

        updateButtons();
        renderComparePage();
        return;
        }

      const removeButton = event.target.closest("[data-ss-remove-compare]");

      if (removeButton) {
        event.preventDefault();
        event.stopPropagation();

        removeCompare(removeButton.dataset.ssRemoveCompare);
        updateButtons();
        renderComparePage();
        return;
      }

      const differenceToggle = event.target.closest("[data-ss-difference-toggle]");

      if (differenceToggle) {
        event.preventDefault();
        event.stopPropagation();

        const root = document.querySelector("[data-ss-compare-root]");
        if (!root) return;

        const isActive = root.getAttribute("data-show-differences-only") === "true";
        const nextState = !isActive;

        root.setAttribute("data-show-differences-only", nextState ? "true" : "false");

        differenceToggle.classList.toggle("is-active", nextState);
        differenceToggle.textContent = nextState
          ? "Differences highlighted"
          : "Highlight differences";

        renderComparePage();
        return;
      }

      const clearButton = event.target.closest("[data-ss-clear-compare]");

      if (clearButton) {
        event.preventDefault();
        event.stopPropagation();

        clearCompare();
        updateButtons();
        renderComparePage();
      }
    },
    true
  );

  document.addEventListener("DOMContentLoaded", function () {
    updateButtons();
    renderComparePage();
  });
})();